import { getCookie } from '@js/globalFunctions/cookieHandling'
import { updateSelectedChangedays } from '@js/parts/search/functions/changeDays/updateSelectedChangedays'
import { updateSelectedAreas } from '@js/parts/search/functions/areaSelector/updateSelectedAreas'
import { updateSelectedDates } from '@js/parts/search/functions/dateSelector/updateSelectedDates'
import { checkAndRemoveCurrentDaySearchOption } from '@js/parts/search/functions/dateSelector/checkAndRemoveCurrentDaySearchOption'
import { removeOldWeeks } from '@js/parts/search/functions/dateSelector/removeOldWeeks'
import { updateTagsView } from '@js/parts/search/functions/searchfilterbox/updateTagsView'
import {updateSearchMode} from "@js/parts/search/functions/searchfilterbox/updateSearchMode";

export function addSelectedSearch(){
	if($('#faneFeriehus').length > 0){
		if(typeof $('#faneFeriehus').attr('data-slug') != 'undefined'){
			var slug = $('#faneFeriehus').attr('data-slug');
			searchParameters.setParameter('omraader',slug)
		}
	}
	if(searchParameters.hasParameters()){
		const obj = searchParameters.getParameters();
		const specials = ['omraader','ankomst','skiftedag','textQuery','searchMode','dateRange'];
		for (var key in obj) {
			if (obj.hasOwnProperty(key)) {
				if( specials.indexOf(key) === -1){
					var el = document.getElementsByName(key)[0];
					if(typeof el != 'undefined'){
						if(el.nodeName === "SELECT"){
							var opt = $('select[name="'+key+'"] option[value="'+ obj[key] +'"]')[0];
							if(typeof opt != "undefined"){
								opt.selected = 'selected';
							}
						}else if(el.nodeName === "INPUT"){
							el.checked = true;
						}
						$(el).addClass('highlight');
					}
				}
				else if( key === 'omraader' )
				{
					if(obj[key] !== false )
					{
						dataholder.selectedAreaHolder = obj[key].split(',');
					}
				}
				else if( key === 'skiftedag' )
				{
					if(obj[key] !== false )
					{
						dataholder.selectedChangedayHolder = obj[key].split(',');
					}

				}
				else if( key === 'ankomst' )
				{
					if(obj[key] !== false )
					{
						dataholder.selectedDatesHolder = typeof obj['specificAnkomst'] !== 'undefined' ? obj['specificAnkomst'].split(',') : obj[key].split(',');
					}
				}
				else if( key === 'dateRange' )
				{
					if(obj[key] !== false )
					{
						$('#dateRange').val(obj[key]);
					}
				}
				else if( key === 'searchMode' )
				{
					if(obj[key] !== false )
					{
						if(obj[key] === dataholder.searchModes.miniferie)
						{
							$('#search-mode-toggle').prop("checked", true)
						}
					}
				}
				else if( key === 'textQuery' )
				{
					var el = document.getElementsByName(key)[0];
					$(el).val(obj[key]).addClass('highlight');
					$('#freeSearchInputField').val(obj[key]);
				}
			}
		}
	}

	if(dataholder.isSearchCalendarActive)
		$('input[name=useSpecificArrival]')[0].checked = searchParameters.getParameter('useSpecificArrival') !== 'True';

	var orderCookie = getCookie('searchOrder');
	if(typeof(orderCookie) != "undefined"){

		$('select.sorting option').each(function(i, e){
			if(e.value === orderCookie){
				e.selected = 'selected';
			}
		});
	}
	updateSelectedChangedays( dataholder.selectedChangedayHolder );
	updateSelectedAreas( dataholder.selectedAreaHolder, true );
	updateSelectedDates( dataholder.selectedDatesHolder );

	dataholder.lastSelectedAreaHolder = dataholder.selectedAreaHolder;

	checkAndRemoveCurrentDaySearchOption();
	removeOldWeeks();

	updateTagsView();
	updateSearchMode();
}
